import { action } from "mobx";
import accessStore from "../accessStore";
import availabilityStore from "../availabilityStore";
import barcodeStore from "../barcodeStore";
import cartTrackingStore from "../cart/cartTrackingStore";
import categoryStore from "../categories/categoryStore";
import claimsStoreNew from "../claims/claimsStore";
import contactFormStore from "../claims-old-version/contactFormStore";
import contentStore from "../cms/contentStore";
import segmentStore from "../cms/segmentStore";
import complianceDocumentStore from "../compliance-documents/complianceDocumentStore";
import deliveryDatesStore from "../deliveryDates/deliveryDatesStore";
import deliveryWindowStore from "../deliveryDates/deliveryWindowStore";
import deliveryFeeStore from "../deliveryFeeStore";
import favoriteStore from "../favoriteStore";
import featuresStore from "../features/featuresStore";
import invoiceStore from "../invoiceStore";
import mockStore from "../mockStore";
import notificationsStore from "../notifications/notificationsStore";
import recipientsStore from "../notifications/recipientsStore";
import orderStore from "../orders/orderStore";
import persistedFormStore from "../persistedFormStore";
import powerBiStore from "../powerBIStore";
import productStore from "../product/productStore";
import promotionStore from "../promotionStore";
import recommendationStore from "../recommendationStore";
import searchStore from "../search/searchStore";
import subscriptionStore from "../subscriptionStore";
import uiStore from "../uiStore";
import authStore from "./authStore";

export const clearAllCompanySpecificStoreData = action(() => {
   authStore.clearCompanySpecificData();
   invoiceStore.clearCompanySpecificData();
   promotionStore.clearCompanySpecificData();
   recommendationStore.clearCompanySpecificData();
   accessStore.clearCompanySpecificData();
   productStore.clearCompanySpecificData();
   deliveryDatesStore.clearCompanySpecificData();
   recipientsStore.clearCompanySpecificData();
   notificationsStore.clearCompanySpecificData();
   claimsStoreNew.clearCompanySpecificData();
   favoriteStore.clearCompanySpecificData();
   segmentStore.clearCompanySpecificData();
   featuresStore.clearCompanySpecificData();
   deliveryWindowStore.clearCompanySpecificData();
   searchStore.clearCompanySpecificData();
   contactFormStore.clearCompanySpecificData();
   availabilityStore.clearCompanySpecificData();
   orderStore.clearCompanySpecificData();
   categoryStore.clearCompanySpecificData();
   deliveryFeeStore.clearCompanySpecificData();
   uiStore.clearCompanySpecificData();
   contentStore.clearCompanySpecificData();
   complianceDocumentStore.clearCompanySpecificData();
   subscriptionStore.clearCompanySpecificData();
   powerBiStore.clearCompanySpecificData();
   barcodeStore.clearCompanySpecificData();
   persistedFormStore.clearCompanySpecificData();
   mockStore.clearCompanySpecificData();
   cartTrackingStore.clearCompanySpecificData();
});
